import { ArrowRight32 } from '@carbon/icons-react';
import clsx from 'clsx';
import Link from 'next/link';
import { FC } from 'react';

export interface ProductCarouselFinalItemProp {
  _uid: string;
  heading: string;
  content: string;
  linkLabel: string;
  linkUrl: string;
}

const ProductCarouselFinalItem: FC<ProductCarouselFinalItemProp> = ({
  heading,
  content,
  linkLabel,
  linkUrl,
}) => {
  const className = {
    containerClass: clsx(
      'cursor-pointer flex flex-col group no-underline relative w-full sm:px-15px sm:py-30px md:p-20px',
      'wl-bg-highlight-after',
      'bg-green60'
    ),
    headingClass:
      ' font-headline mb-30px font-weight-bold text-headline4 text-purple80 monochrome:text-black',
    contentClass: 'text-purple80 monochrome:text-black pb-30px',
    arrowRightClass:
      ' h-20px w-20px text-purple80 monochrome:text-black mr-5px',
    linkClass: 'flex items-center absolute bottom-20px left-20px',
    linkLabel: 'text-purple80 monochrome:text-black font-weight-bold underline',
  };
  return (
    <Link
      href={linkUrl ?? '/'}
      className={className.containerClass}
      style={{ minHeight: 350 }}
    >
      <h5 className={className.headingClass}>{heading}</h5>
      <p className={className.contentClass}>{content}</p>
      <div className={className.linkClass}>
        <ArrowRight32 className={className.arrowRightClass} />
        <p className={className.linkLabel}>{linkLabel}</p>
      </div>
    </Link>
  );
};

export default ProductCarouselFinalItem;
